import { render } from "./j-code.vue?vue&type=template&id=471e8ffe&scoped=true"
import script from "./j-code.vue?vue&type=script&lang=js"
export * from "./j-code.vue?vue&type=script&lang=js"

import "./j-code.vue?vue&type=style&index=0&id=471e8ffe&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471e8ffe"]])

export default __exports__